import { render, staticRenderFns } from "./Cola1.vue?vue&type=template&id=3e8747bf"
import script from "./Cola1.vue?vue&type=script&lang=js"
export * from "./Cola1.vue?vue&type=script&lang=js"
import style0 from "./Cola1.vue?vue&type=style&index=0&id=3e8747bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports